<template>
  <div>
    <div class="selectDishGroup">
      <div class="row mb-3">
        <div v-if="selectedGroup" class="col-12 text-right pt-1">
          <!--    <b-button v-if="selectedGroupHistory.length > 0" type="button"
                              :variant="selectedGroupHistory.length > 0 ? 'danger' : 'light'"
                              :disabled="selectedGroupHistory.length < 1"
                              class="text-nowrap"
                              @click="dishGroupBack()">
                        <span class="mdi mdi-arrow-left-bold"></span> Back
                    </b-button>-->
          <b-button v-if="selectedGroup.parent"
                    type="button"
                    variant="danger"
                    class="text-nowrap"
                    @click="dishGroupBack()">
            <span class="mdi mdi-arrow-left-bold"></span> {{ $t("#TR-back") }}
          </b-button>

        </div>
      </div>

      <b-list-group v-if="dishGroupList.length > 0" class="mb-3">
        <b-list-group-item v-for="group in dishGroupList"
                           :key="group.sifr"
                           :active="selectedGroup && group.sifr === selectedGroup.sifr"
                           button
                           class="p-0 d-flex justify-content-between align-items-center">
          <div class="p-2" style="flex: auto; font-weight: 600; color: #616161"
               @click="selectGroup(group)">
            {{ group.name }}
          </div>
          <div v-if="group['hasChilds']"
               class="mdi mdi-menu-right mdi-24px p-2"
               @click="getChildGroup(group)">
          </div>
        </b-list-group-item>
      </b-list-group>

    </div>

  </div>
</template>
<script>

  import { ApiDishGroup } from '@/services/api';
  import MSG from '@/services/notify';

  export default {
    name: 'DishGroupSelector',

    data() {
      return {
        dishGroupList: [],
        selectedGroup: null
        // selectedGroupHistory: []
      };
    },

    created() {
      // this.getDishGroup();
    },

    methods: {

      async getDishGroup(sifr = null, select = true) {
        this.dishGroupList = [];
        const result = await ApiDishGroup.list(sifr);
        if (result.error) {
          MSG.error(result.error, this);
        } else {
          this.dishGroupList = result.data;

          if (select) {
            this.selectGroup(this.dishGroupList[0]);
            this.selectedGroup = this.dishGroupList[0];
          }
        }
      },

      async getChildGroup(group) {
        // this.selectedGroupHistory.push(group);
        await this.getDishGroup(group.sifr);
        this.selectGroup(this.dishGroupList[0]);
        this.selectedGroup = this.dishGroupList[0];
      },

      selectGroup(group) {
        this.$emit('selectDishGroup', group);
        this.selectedGroup = group;
      },

      async dishGroupBack() {

        if (this.selectedGroup.parent === null) {
          await this.getDishGroup();

          return;
        }
        const parentGroup = await ApiDishGroup.get(this.selectedGroup.parent);
        await this.getDishGroup(parentGroup.data.parent);
      },

      async openCategory(groupSifr = null) {
        if (!groupSifr) {
          this.getDishGroup();
        } else {
          const parentGroup = await ApiDishGroup.get(groupSifr);
          await this.getDishGroup(parentGroup.data.parent, false);

          this.selectedGroup = parentGroup.data;
          this.selectGroup(parentGroup.data);
        }
      }


      /* async dishGroupBack2() {

            if (this.selectedGroup.parent === null) {
                await this.getDishGroup();
                this.selectedGroupHistory = [];

                return;
            }

            const findGroupIdx = this.selectedGroupHistory.findIndex(r => r['sifr'] === this.selectedGroup.parent);

            if (findGroupIdx !== -1) {
                await this.getDishGroup(this.selectedGroupHistory[findGroupIdx].parent);

                if (this.selectedGroupHistory[findGroupIdx].parent === null) {
                    this.selectedGroupHistory = [];
                }

            } else {
                await this.getDishGroup();
                this.selectedGroupHistory = [];
            }
        } */

    }
  };
</script>

<style lang="stylus">

.list-group-item-action {
    margin: 0;
    outline: none
    border: none
    border-bottom 1px solid #dee2e6
}

.list-group-item-action:hover {
    background-color: #eee;

  .mdi-menu-right {
    color: #444 !important
  }
}


.list-group-item + .list-group-item.active {
    margin-top: 0;
}

.list-group-item.active  {
  .mdi-menu-right {
    color: c-body-font-dark
  }
}


</style>
